//AUTH USERS
export const FETCH_USER_DETAILS = "fetchuserdetails";

export const UPDATE_PROFILE_PROGRESS = "updateprofileprogress";

export const RESET_USER_DETAILS = "resetuserdetails";
